module.exports = __webpack_public_path__ + "static/media/Rectangle 36.e283897a.svg";